// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { PrivacyPolicyPage } from '../pages/PrivacyPolicyPage/PrivacyPolicyPage';

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicyPage,
});
